import { createFileRoute, redirect } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

// Data protection moved to the legal page (DNI-857); keep the old URL working.
export const Route = createFileRoute('/(main)/settings/data-protection/')({
  beforeLoad: () => {
    throw redirect({
      replace: true,
      search: { tab: 'privacy' },
      to: '/legal',
    });
  },
});

export const SETTINGS_DATA_PROTECTION = buildRouteExport({
  Route,
});
